import Vue from 'vue';
import {format, parseISO} from 'date-fns/esm';

Vue.filter('formatDate', (value: any, dateFormat?: string) => {
  return formatDate(value, dateFormat);
});


export function formatDate(value: any, dateFormat?: string) : string  {
  if (value) {
    return format(value, dateFormat ? dateFormat : 'dd/MM/yyyy HH:mm:ss');
  }

  return '';
};

export function parseDate(value: string): Date {
  const tIndex = value.indexOf('T');

  if (tIndex === -1) {
    return parseISO(value);
  } else {
    const plusIndex = value.indexOf('+', tIndex);
    const minusIndex = value.indexOf('-', tIndex);
    const stripFrom = plusIndex > -1 ? plusIndex : minusIndex > -1 ? minusIndex : value.length;

    return parseISO(value.slice(0,stripFrom));
  }
};




// WEBPACK FOOTER //
// node_modules/wc-lib/src/wc-converters/datetime.ts